import { locatePath } from '../../common/RelativeUrl';
import { CourseId } from '../types/course';
import { CoachId } from '../../adminv2/types/course';
export function v1Path(path: string): string {
  return locatePath(path);
}
import { LessonId } from '../types/lesson';
import * as queryString from 'querystring';
import { LocationDescriptorObject } from 'history';
import { EventId } from '../types/event';
import { TrialLessonId } from '../../admin/types/trial';
import { AnswerCode } from '../types/diagnosis';

export function v2Path(path: string): string {
  return locatePath('/' + path);
}

export const V2Routes = {
  topPage(anchor?: string): LocationDescriptorObject {
    return {
      pathname: v2Path(''),
      hash: anchor,
    };
  },
  applicationPage(selectedPlanId?: number): LocationDescriptorObject {
    return {
      pathname: v2Path('application'),
      search: selectedPlanId ? queryString.stringify({ planId: selectedPlanId }) : undefined,
    };
  },
  courseDetailsPage(courseId: CourseId) {
    return v2Path(`courses/${courseId}`);
  },
  courseReservationPage(courseId: CourseId, lessonIds: LessonId[]): LocationDescriptorObject {
    return {
      pathname: v2Path(`courses/${courseId}/reservation`),
      search: queryString.stringify({ lessonIds: lessonIds.join(',') }),
    };
  },
  eventDetailsPage(eventId: EventId): LocationDescriptorObject {
    return {
      pathname: v2Path(`events/${eventId}`),
    };
  },
  eventReservationPage(eventId: EventId): LocationDescriptorObject {
    return {
      pathname: v2Path(`events/${eventId}/reservation`),
    };
  },
  coachDetailsPage(coachId: CoachId) {
    return v1Path(`coaches/${coachId}`);
  },
  myPage(): LocationDescriptorObject {
    return {
      pathname: v2Path('mypage'),
    };
  },
  updateUserInfoPage(): LocationDescriptorObject {
    return {
      pathname: v2Path('mypage/settings/userinfo'),
    };
  },
  updateUserInfoCompletePage(): LocationDescriptorObject {
    return {
      pathname: v2Path('mypage/settings/userinfo/complete'),
    };
  },
  cardUpdatePage() {
    return {
      pathname: v2Path(`mypage/settings/card`),
    };
  },
  changePasswordPage(): LocationDescriptorObject {
    return {
      pathname: v2Path('mypage/settings/password'),
    };
  },
  changePasswordCompletePage(): LocationDescriptorObject {
    return {
      pathname: v2Path('mypage/settings/password/complete'),
    };
  },
  signInPage(from?: string): LocationDescriptorObject {
    from = from || v2Path('');
    return {
      pathname: v2Path('sign_in'),
      search: queryString.stringify({ from }),
    };
  },
  signOutPage() {
    return {
      pathname: v2Path('sign_out'),
    };
  },
  accessPage(): LocationDescriptorObject {
    return {
      pathname: v2Path('access'),
    };
  },
  faqPage(): LocationDescriptorObject {
    return {
      pathname: v2Path('faq'),
    };
  },
  trialLessonsPage(): LocationDescriptorObject {
    return {
      pathname: v2Path('trial_lessons'),
    };
  },
  trialPage(): LocationDescriptorObject {
    return {
      pathname: v2Path('trial'),
    };
  },
  trialReservationPage(id: TrialLessonId): LocationDescriptorObject {
    return {
      pathname: v2Path(`trial_lessons/${id}/reservation`),
    };
  },
  courseTrialPage(courseId: CourseId): LocationDescriptorObject {
    return {
      pathname: v2Path(`courses/${courseId}/trial`),
    };
  },
  visitReservationPage(lessonId: LessonId): LocationDescriptorObject {
    return {
      pathname: v2Path(`lessons/${lessonId}/reservation`),
    };
  },
  diagnosisPage(): LocationDescriptorObject {
    return {
      pathname: v2Path('diagnosis'),
    };
  },
  diagnosisResultPage(code: AnswerCode): LocationDescriptorObject {
    return {
      pathname: v2Path(`diagnosis/${code}`),
    };
  },
};
